import { createContext } from 'react';

/**
 * BE-resolved section-availability flags for the v2 subscription-management surface, sourced from
 * the `/preflight` loader. Kept separate from tab state so the `?tab=` selection concern
 * (`TabStateProvider`) stays decoupled from the data fetch and from tab-list derivation (which now
 * lives in `PageInner`). Consumers: `PageInner` (derives the visible tab list) and `PodcastsProvider`
 * (gates its lazy shows fetch).
 */
export type PreflightContextType = {
  hasOrders: boolean;
  hasPodcasts: boolean;
  hasGroups: boolean;
  hasAdminBilling: boolean;
};

export const PreflightContext = createContext<PreflightContextType | undefined>(undefined);
PreflightContext.displayName = 'PreflightContext';
